<template>
  <div>
    <px-view-header title="Aprovações de solicitação"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>

    <px-aprovacao-solicitacao-header :on-click-refresh="onClickRefresh"
                                     @change="onChange"/>
    <px-aprovacao-solicitacao-list class="mt-3"/>
  </div>
</template>

<script>
import AprovacaoSolicitacaoHeader
  from '@/modules/aprovacao-solicitacao/AprovacaoSolicitacaoHeader.vue';
import AprovacaoSolicitacaoList from '@/modules/aprovacao-solicitacao/AprovacaoSolicitacaoList.vue';

export default {
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        {
          text: 'Aprovações de solicitação',
        },
      ],
    };
  },
  methods: {
    onClickRefresh() {
    },
    onChange() {},
  },
  components: {
    pxAprovacaoSolicitacaoHeader: AprovacaoSolicitacaoHeader,
    pxAprovacaoSolicitacaoList: AprovacaoSolicitacaoList,
  },
};
</script>
